export default __webpack_public_path__ + "pgnv-assets/a5a16b367926231b6079ae531371b789.svg";